<template>
  <div class="modal__body">
    <section class="card">
      <p class="card__title">Porcentaje de avance</p>

      <div class="radial card-bordered">
        <radial-chart :value="data.progress.percent?.toFixed(2)" label="Gestion total" percent />

        <span class="progress">{{ strategyProgress }}</span>
      </div>
    </section>

    <section class="card card--stat">
      <p class="card__title">
        <span> Grupos </span>
        <span> Cantidad de teléfonos </span>
      </p>

      <a-divider class="divider" />

      <IvrStatusChart :data="data" />
    </section>

    <section class="card chart">
      <VueApexCharts
        v-if="showDashboard"
        class="chart__graph"
        type="donut"
        height="80%"
        :options="chartConfig.options"
        :series="chartConfig.series"
      />

      <span v-else class="chart__message">No hay suficientes datos para mostrar el gráfico</span>
    </section>
  </div>
</template>

<script setup lang="ts">
import { inject, computed } from "vue";
import VueApexCharts from "vue3-apexcharts";

import type { IvrData } from "@/@types/strategies/dashboard";

import IvrStatusChart from "../../charts/IvrStatusChart.vue";
import RadialChart from "@/app/strategies/components/charts/RadialChart.vue";

const props = defineProps<{ data: IvrData }>();

const strategyProgress = inject("strategyProgress");

const chartConfig = computed(() => {
  const options = {
    chart: { type: "donut", width: "100%" },
    labels: ["Contestado", "No contesta", "Ocupada", "Fallada"],
    colors: ["#87E8DE", "#FFE58F", "#B7EB8F", "#EAFF8F"],
    legend: { show: false },
  };

  const series = [
    props.data.total_answer,
    props.data.total_no_answer,
    props.data.total_busy,
    props.data.total_failed,
  ];

  return { options, series };
});

const showDashboard = computed(() => !chartConfig.value.series.every((value) => value === 0));
</script>

<style scoped lang="sass">
.modal
  &__body
    color: $gray-9
    height: 500px
    display: grid
    grid-template-columns: repeat(2, 1fr)
    grid-template-rows: repeat(3, 1fr)
    gap: 20px

  &__picker
    margin-bottom: 12px

  &__paragraph
    margin: 16px 0

.radial
  display: grid
  place-content: center
  padding: 10px 0

  .progress
    text-align: center

.divider
  background-color: $gray-6
  margin: 0
  margin-bottom: 6px

.card
  padding: 5px 10px

  &-bordered
    border: $border-normal
    border-radius: 2px

  &__title
    font-weight: 600
    margin: 0
    display: flex
    justify-content: space-between
    width: 100%
    color: $gray-9
    margin-bottom: 6px

  &.chart
    display: flex
    justify-content: center
    align-items: center

  &__icon
    font-size: 32px
    margin: 4px 0

    & img
      display: block
      margin: 6px 0
      height: 36px

    &--red
      color: $red-6

  &__value
    font-size: 30px
    line-height: 38px
    margin-bottom: -4px

  &__accordion
    padding: 0

  &--stat
    display: flex
    flex-direction: column
    align-items: center

  &:nth-child(1)
    grid-column: 1 / 2
    grid-row: 1 / 2

  &:nth-child(2)
    grid-column: 1 / 2
    grid-row: 2 / 4

  &:nth-child(3)
    grid-column: 2 / 3
    grid-row: 1 / 4

.chart
  &__graph
    width: 100%

  &__message
    color: $gray-6
</style>
